/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  let refreshing = false

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })

  const makeUpdateAvailable = (registration) => {
    window.__TIME_CLOCK_PENDING_UPDATE__ = registration
    window.dispatchEvent(new CustomEvent('timeclock-app-update-available'))
  }

  window.__ACTIVATE_TIME_CLOCK_UPDATE__ = () => {
    const registration = window.__TIME_CLOCK_PENDING_UPDATE__
    if (!registration || !registration.waiting) return false

    registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    return true
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      // Long-running kiosk tabs do not navigate often, so explicitly check for
      // a newly deployed service worker every five minutes.
      setInterval(() => registration.update(), 5 * 60 * 1000)
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; waiting for the kiosk to be idle.')
      makeUpdateAvailable(registration)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
